<div class="contenedor_filtro">
    <div class="chip-container">
      <mat-chip-set>
        <mat-chip class="chip-with-icon" (click)="openDatePicker()">
          <i-tabler name="calendar" class="calendar" style="color: #003c8a;"></i-tabler>
          <span style="font-weight: bold; color: #003c8a;"> {{ desde }} - {{ hasta }} </span>
        </mat-chip>
      </mat-chip-set>       &nbsp;&nbsp;&nbsp;&nbsp;
    
      <div class="chip-options-container">
        <mat-chip-option 
          *ngFor="let fecha of filtrosf; let i = index" 
          [selected]="selectedChipIndex === i"
          (click)="selectChip(i)"
          [ngClass]="{'selected-chip': selectedChipIndex === i, 'disabled': selectedChipIndex === i}">
          <span class="fechaselector">{{ fecha }}</span>
        </mat-chip-option>
      </div>
    </div>
    
    <hr>

    <form @slideInFromTop [formGroup]="formFilter" cForm class="container-filter oculto">
      <div (click)="openDatePicker()">
        <mat-form-field>
          <mat-label>Elige el rango de dias</mat-label>
          <mat-date-range-input
            [formGroup]="formFilter"
            [rangePicker]="picker"
            format="dd/MM/YYYY"
          >
            <input
              (keyup.enter)="filtrarPorFecha()"
              matStartDate
              formControlName="start"
            />
            <input
              (keyup.enter)="filtrarPorFecha()"
              matEndDate
              formControlName="end"
              (closed)="filtrarPorFecha()"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle class="colorInge" matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker (closed)="filtrarPorFecha()" touchUi startView="multi-year" #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </form>
</div>
<br>